import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {SettingsPage} from "./page/settings/settings.page";
import {ProfileComponent} from "./component/profile/profile.component";
import {DividerModule} from "primeng/divider";
import {ChangePasswordComponent} from "./component/change-password/change-password.component";
import {PasswordModule} from "primeng/password";
import {UsNotificationsComponent} from "./component/notifications/us-notifications.component";
import {UpdateEmailComponent} from "./component/update-email/update-email.component";
import {UpdatePhoneComponent} from "./component/update-phone/update-phone.component";
import {InputGroupModule} from "primeng/inputgroup";
import {InputGroupAddonModule} from "primeng/inputgroupaddon";
import {DeleteAccountComponent} from "./component/delete-account/delete-account.component";
import {AppInfoComponent} from "./component/app-info/app-info.component";
import {TermsAndConditionsComponent} from "./component/terms-and-conditions/terms-and-conditions.component";
import {PrivacyPolicyComponent} from "./component/privacy-policy/privacy-policy.component";
import {ReferFriendComponent} from "./component/refer-friend/refer-friend.component";
import {CrossModule} from "../cross/cross.module";
import {ImageCropperModule} from "ngx-image-cropper";
import {AgbInfoComponent} from "./component/agb/agb-info.component";

@NgModule({
  declarations: [
    SettingsPage,
    ProfileComponent,
    ChangePasswordComponent,
    UsNotificationsComponent,
    UpdateEmailComponent,
    UpdatePhoneComponent,
    DeleteAccountComponent,
    AppInfoComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    ReferFriendComponent,
    AgbInfoComponent,

  ],
  exports:[
    SettingsPage,
    ProfileComponent,
    ChangePasswordComponent,
    UsNotificationsComponent,
    UpdateEmailComponent,
    UpdatePhoneComponent,
    DeleteAccountComponent,
    AppInfoComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    ReferFriendComponent,
    AgbInfoComponent,

  ],
    imports: [
        CoreModule,
        DividerModule,
        PasswordModule,
        InputGroupModule,
        InputGroupAddonModule,
        CrossModule,
    ]
})
export class UsModule { }



